module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_green_01-7117c196ba3a65924f31abedaf7e6310.svg";